
namespace RioERP.Masters {
    export class BrandAmbassadorSettingsColumns {
        static columnsKey = 'Masters.BrandAmbassadorSettings';
    }
}